import { createFileRoute } from '@tanstack/react-router';
import { OrganizationMergePage } from '@features/admin/organization-merge';

export const Route = createFileRoute('/admin/organization-merge/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <OrganizationMergePage />;
}
